module.exports = __webpack_public_path__ + "img/abnormal_notification_black.88e8d361.svg";